import { createFileRoute } from "@tanstack/react-router";

import { supabase } from "@/integrations/supabase/client";
import { routeHead } from "@/lib/seo-head";
import ProjetDetail from "@/pages/ProjetDetail";

export const Route = createFileRoute("/projets_/$slug")({
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("projects")
      .select("title, description, cover_image, location")
      .eq("slug", params.slug)
      .eq("published", true)
      .maybeSingle();
    return { project: data };
  },
  head: ({ params, loaderData }) => {
    const project = loaderData?.project;
    if (!project) {
      return routeHead({
        path: `/projets/${params.slug}`,
        title: "Projet introuvable | JIIA Studio",
        description: "Ce projet n'existe pas ou n'est plus disponible.",
      });
    }
    const plain = (project.description ?? "").replace(/<[^>]*>/g, "").trim();
    return routeHead({
      path: `/projets/${params.slug}`,
      title: `${project.title} | Projet JIIA Studio`,
      description:
        plain.slice(0, 160) ||
        `Découvrez le projet ${project.title}${project.location ? ` à ${project.location}` : ""}, réalisé par JIIA Studio.`,
      type: "article",
      image: project.cover_image,
    });
  },
  component: ProjetDetail,
});
